/**
 * Bing Webmaster Tools configuration (SGL-134).
 *
 * Bing connects with the owner's own API key, not OAuth (Sourav, ai-agent-management
 * PR #385), so there is no client id and no redirect URI to configure: the card needs
 * nothing from the environment to work.
 */

/**
 * When false the Connect card is not rendered at all. On by default, like the GSC and
 * Google Drive cards; set REACT_APP_BING_ENABLED=false (Amplify Console, per branch)
 * to force it off.
 */
export function isBingConfigured(): boolean {
  return process.env.REACT_APP_BING_ENABLED !== "false";
}
